<script setup lang="ts">
import logoUrl from '../assets/logo.svg'
import { app } from '@shared/lib/app'
import { onMounted } from 'vue'
import { institution, loadInstitution } from '../lib/institution'

onMounted(() => void loadInstitution())
</script>

<template>
  <div class="home">
    <main id="main-content" class="home-main">
      <header class="identity">
        <img class="identity__logo" :src="logoUrl" alt="Logo instansi" width="84" height="84" />
        <h1>{{ institution.name }}</h1>
        <p v-if="institution.address">{{ institution.address }}</p>
      </header>
      <section class="card">
        <slot />
      </section>
      <p class="app-version">{{ app.label }}</p>
    </main>
  </div>
</template>

<style scoped>
/* Light, quiet login surface: white page, one faint teal wash at the top.
   Static CSS only: no animation, no images, no canvas. */
.home {
  min-height: 100vh;
  display: flex;
  justify-content: center;
  padding: 40px 16px;
  color: var(--ink);
  background:
    radial-gradient(ellipse 70% 40% at 50% 0%, rgba(15, 118, 110, 0.07), transparent 70%),
    #ffffff;
}

.home-main {
  width: 100%;
  max-width: 400px;
  margin: auto;
  text-align: center;
}

.identity {
  margin-bottom: 28px;
}

.identity__logo {
  display: block;
  width: 72px;
  height: 72px;
  margin: 0 auto 16px;
}

.identity h1 {
  margin: 0 0 6px;
  font-size: 1.35rem;
  font-weight: 650;
  line-height: 1.3;
  letter-spacing: -0.015em;
  color: var(--ink);
}

.identity p {
  margin: 0;
  font-size: 0.875rem;
  line-height: 1.5;
  color: var(--muted);
}

.app-version {
  margin: 20px 0 0;
  font-size: 0.75rem;
  color: var(--muted);
}

.card {
  padding: 28px 26px;
  border: 1px solid var(--line);
  border-radius: 16px;
  background: #fff;
  color: var(--ink);
  text-align: left;
  box-shadow: 0 1px 2px rgba(20, 33, 43, 0.04), 0 12px 32px rgba(20, 33, 43, 0.06);
}
</style>
